import Box from '@mui/material/Box';
import { motion } from 'framer-motion';
import { ReactNode } from 'react';

export const drawerWidth = 240;
export const leftSidebarVariantAnimation = {
    open: {
        x: 0,
        width: drawerWidth,
        transition: {
            ease: 'linear',
            duration: 0.1,
        },
    },
    closed: {
        x: -drawerWidth,
        width: 0,
        transition: {
            ease: 'linear',
            duration: 0.1,
        },
    },
};
export const rightSidebarVariantAnimation = {
    open: {
        x: 0,
        width: drawerWidth,
        transition: {
            ease: 'linear',
            duration: 0.1,
        },
    },
    closed: {
        x: drawerWidth,
        width: 0,
        transition: {
            ease: 'linear',
            duration: 0.1,
        },
    },
};

type SidebarProps = {
    children: ReactNode;
    open: boolean;
    side: 'left' | 'right';
};

export default function Sidebar({
    children,
    open,
    side = 'left',
}: SidebarProps) {
    return (
        <Box
            zIndex={999}
            variants={
                side === 'left'
                    ? leftSidebarVariantAnimation
                    : rightSidebarVariantAnimation
            }
            animate={open ? 'open' : 'closed'}
            initial={open ? 'open' : 'closed'}
            component={motion.div}
            sx={{
                position: 'relative',
                width: drawerWidth,
                top: 0,
                left: 0,
                borderRight: (theme) =>
                    side === 'left' ? `1px solid ${theme.palette.divider}` : 0,
                borderLeft: (theme) =>
                    side === 'right' ? `1px solid ${theme.palette.divider}` : 0,
            }}
        >
            <Box width={drawerWidth} height="100%">
                {children}
            </Box>
        </Box>
    );
}
